import Step2WbbHomepageContent from "./Steps/Step2WbbHomepageContent.jsx";
import WbbHomepage from "./Templates/WbbHomepage.jsx";
import wbbHomepageEditorConfig from "./EditorConfigs/wbbHomepageEditorConfig.js";

const wbbTemplates = {
 "wbb-homepage": {
  id: "wbb-homepage",
  name: "WBB-Homepage",
  label: "SF Pickup WBB",
  desc: "Women’s basketball tournament homepage",
  pageType: "home",
  step2Component: Step2WbbHomepageContent,
  publicComponent: WbbHomepage,
  editorConfig: wbbHomepageEditorConfig,
 },
};

export default wbbTemplates;